<template>
	<svg class="marcadagua" xmlns="http://www.w3.org/2000/svg">
		<defs>
        <pattern id="marcadagua" patternUnits="userSpaceOnUse" x="0" y="0" width="100" height="200">
            <text style="font: 17px/1 monospace" x="-422" y="428" transform="rotate(-45 -600 -250)">
                <tspan x="-422" dy="1.2em">{{ login }}</tspan>
                <tspan x="-422" dy="1.2em">{{ dataAtual }}</tspan>
            </text>
        </pattern>
    </defs>
		<rect fill="url(#marcadagua)" width="100%" height="100%"></rect>
	</svg>
</template>

<script>
export default {
	computed: {
		dataAtual(){
			return moment().format("DD/MM/YYYY")
		},
		login() {
			return $sessao.getNome()
		}
	}
}
</script>
